import React from 'react'

export const Layout = React.lazy(() => import('@/components/Layout'))
export const NoAuth = React.lazy(() => import('@/page/NoAuth'))
export const Index = React.lazy(() => import('@/page/Index'))
export const Djzp = React.lazy(() => import('@/page/Djzp'))
export const Bidregister = React.lazy(() => import('@/page/Bidregister'))
